import { render, staticRenderFns } from "./FormPromo.vue?vue&type=template&id=1507b9c3&"
import script from "./FormPromo.vue?vue&type=script&lang=js&"
export * from "./FormPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports